import Category from "../components/Processes/conversations/utils/categories.json";

export const CATEGORIES = Category.filter(
  (cat) => cat?.code !== "EMPLOYEE_INFORMATION",
);
